import type { ReactElement, SVGProps } from 'react';
import useInlineStyles from '@components/sds/useInlineStyles';
import inlineStyles from './loading.module.scss?inline';

export default function LoadingIcon({
  className,
  ...props
}: SVGProps<SVGSVGElement>): ReactElement {
  const clsx = useInlineStyles(inlineStyles);
  const classNames: string[] = [clsx({ loading: true })];

  if (typeof className !== 'undefined') {
    classNames.push(className);
  }

  return (
    <svg
      focusable={false}
      role="presentation"
      xmlns="http://www.w3.org/2000/svg"
      width="65"
      height="65"
      fill="none"
      viewBox="0 0 65 65"
      className={classNames.join(' ')}
      {...props}
    >
      <path
        fill="currentColor"
        d="m57.52 24.153 6.254 6.253h-.002c.628.628.955 1.497.897 2.386a2.96 2.96 0 0 1-1.14 2.155 23.707 23.707 0 0 1-7.438 3.836 23.563 23.563 0 0 1-21.967-4.404c4.305 6.1 11.248 9.757 18.788 9.757a24.017 24.017 0 0 0 3.06-.191l.308-.037v9.157c0 .886-.383 1.733-1.054 2.321a2.96 2.96 0 0 1-2.328.716 23.618 23.618 0 0 1-7.97-2.543A23.565 23.565 0 0 1 32.5 34.774c-1.383 7.743 1.257 15.657 7.159 21.05a26.93 26.93 0 0 0 1.537 1.3l.242.194-.22.219-6.254 6.252a3.094 3.094 0 0 1-2.386.898 2.946 2.946 0 0 1-2.153-1.142 23.655 23.655 0 0 1-3.837-7.434 23.573 23.573 0 0 1 4.495-22.073C24.63 38.537 20.9 45.995 21.259 53.984c.025.696.097 1.375.168 2.005l.035.309h-9.153a3.096 3.096 0 0 1-2.321-1.055 2.957 2.957 0 0 1-.715-2.328 23.69 23.69 0 0 1 2.544-7.971 23.566 23.566 0 0 1 18.781-12.43c-7.738-1.381-15.652 1.256-21.046 7.158-.4.429-.799.904-1.3 1.534l-.193.245-6.474-6.472a3.096 3.096 0 0 1-.895-2.393 2.942 2.942 0 0 1 1.14-2.148 23.672 23.672 0 0 1 7.436-3.837 23.571 23.571 0 0 1 22.068 4.492c-4.499-6.45-11.953-10.165-19.943-9.824-.723.028-1.42.1-2.008.169l-.309.034V12.32A3.08 3.08 0 0 1 10.13 10c.646-.568 1.49-.84 2.328-.716a23.615 23.615 0 0 1 7.971 2.543 23.565 23.565 0 0 1 12.43 18.785c1.381-7.743-1.258-15.657-7.16-21.051a26.979 26.979 0 0 0-1.537-1.299l-.242-.194.22-.219 6.254-6.253A3.175 3.175 0 0 1 32.78.699c.856.055 1.64.473 2.155 1.142 1.71 2.229 3 4.732 3.834 7.434a23.572 23.572 0 0 1-4.494 22.073c6.453-4.499 10.182-11.958 9.824-19.946a26.128 26.128 0 0 0-.168-2.005l-.035-.309h9.153c.888 0 1.735.385 2.32 1.054.564.644.827 1.493.716 2.328a23.618 23.618 0 0 1-2.542 7.97 23.567 23.567 0 0 1-18.785 12.43c7.75 1.387 15.657-1.257 21.05-7.157a27.52 27.52 0 0 0 1.298-1.537l.194-.242.22.22Z"
      />
    </svg>
  );
}
